import * as Net from 'util/Net';

export interface CreateDataCaptureAssistantChatResponse {
  chatId: string;
}

interface StartWebRTCRealtimeVoiceSessionResponse {
  sdpAnswer: string;
}

/**
 * For a given Compose chat session, start a realtime session with the OpenAI API.
 */
export async function startWebRTCRealtimeVoiceSession(
  chatSessionId: string,
  sdpOffer: string
): Promise<StartWebRTCRealtimeVoiceSessionResponse> {
  return await Net.postJSONPromise({
    url: `/1/api/llm/data-capture-assistant/chats/${chatSessionId}:start-webrtc-realtime-voice-session`,
    data: {sdpOffer},
  });
}

export interface VoiceToolInvocationItem {
  name: string;
  callId: string;
  args: string;
}

export interface VoiceToolInvocationResponse {
  output: string;
}

/**
 * In the context of a realtime voice session, execute a tool invoked by the LLM.
 * Note that the tool name and args have not been validated at this point and must be
 * validated by the server.
 */
export async function invokeVoiceTool(
  chatSessionId: string,
  item: VoiceToolInvocationItem
): Promise<VoiceToolInvocationResponse> {
  return await Net.postJSONPromise({
    url: `/1/api/llm/data-capture-assistant/chats/${chatSessionId}:invoke-voice-tool`,
    data: {item},
  });
}
